import {
  GET_LABAREA,
  GET_LABAREA_FAIL,
  GET_LABAREA_SUCCESS,
  GET_LABAREAS,
  GET_LABAREAS_FAIL,
  GET_LABAREAS_SUCCESS,
  ADD_NEW_LABAREA,
  ADD_LABAREA_SUCCESS,
  ADD_LABAREA_FAIL,
  UPDATE_LABAREA,
  UPDATE_LABAREA_SUCCESS,
  UPDATE_LABAREA_FAIL,
  DELETE_LABAREA,
  DELETE_LABAREA_SUCCESS,
  DELETE_LABAREA_FAIL,
  SET_STATE_LABAREA,
  UPDATE_LABAREA_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABAREA,
  payload: loading,
})

export const getLabAreas = ( params ) => ({
  type: GET_LABAREAS,
  payload: { params },
})

export const getLabAreasSuccess = (labareas, totalPages, currentPage) => ({
  type: GET_LABAREAS_SUCCESS,
  payload: {labareas:labareas, total:totalPages, currentPage:currentPage}
})

export const getLabAreasFail = error => ({
  type: GET_LABAREAS_FAIL,
  payload: error,
})

export const addNewLabArea = labarea => ({
  type: ADD_NEW_LABAREA,
  payload: labarea,
})

export const addLabAreaSuccess = labarea => ({
  type: ADD_LABAREA_SUCCESS,
  payload: labarea,
})  

export const addLabAreaFail = error => ({
  type: ADD_LABAREA_FAIL,
  payload: error,
})

export const updateLabArea = labarea => ({
  type: UPDATE_LABAREA,
  payload: labarea,
})

export const updateLabAreaStatus = labarea => ({
  type: UPDATE_LABAREA_STATUS,
  payload: labarea,
})

export const updateLabAreaSuccess = labarea => ({
  type: UPDATE_LABAREA_SUCCESS,
  payload: labarea,
})

export const updateLabAreaFail = error => ({
  type: UPDATE_LABAREA_FAIL,
  payload: error,
})

export const deleteLabArea = labarea => ({
  type: DELETE_LABAREA,
  payload: labarea,
})

export const deleteLabAreaSuccess = id => ({
  type: DELETE_LABAREA_SUCCESS,
  id,
})

export const deleteLabAreaFail = error => ({
  type: DELETE_LABAREA_FAIL,
  payload: error,
})

export const getLabArea = () => ({
  type: GET_LABAREA,
})

export const getLabAreaSuccess = labarea => ({
  type: GET_LABAREA_SUCCESS,
  payload: labarea,
})

export const getLabAreaFail = error => ({
  type: GET_LABAREA_FAIL,
  payload: error,
})
